function getQueryParams() {
  if (!window.location.search) {
    return {};
  }
  return window.location.search
    .replace("?", "")
    .split("&")
    .reduce(
      (r, e) => (
        (r[e.split("=")[0].toLowerCase()] = decodeURIComponent(
          e.split("=")[1]
        )),
        r
      ),
      {}
    );
}

module.exports = getQueryParams;
